// src/components/DecoLogin.js
import React from 'react';
import { Container } from 'react-bootstrap';
import logo from '../../../utils/logo500.png';

function DecoLogin() {
    return (
<Container className="text-center d-flex flex-column justify-content-center w-100">
            <img 
                src={logo}
                alt='Rey Midas'
                className="img-fluid"  // Evita que la imagen sea más grande que su contenedor
                style={{ maxWidth: "100%", height: "auto" }} // Ajuste extra
            />
        </Container>
    );
}

export default DecoLogin;